import date from 'date-and-time';
import styled from 'styled-components';

import NotificationInfoBar from '~/components/account/limits/notification';

const StyledUl = styled.ul`
	.limits-notification-wrapper {
		margin-top: 20px;
	}
	.limits-notification-message-wrapper {
		text-align: left;
	}
`;

const ErrorInfoLabel = ({ info, hideTime = false }) => {
	const updateTime = hideTime ? null : date.format(new Date(), 'D MMMM YYYY, h:mm A');
	return (
		<StyledUl className="my-limits-menu">
			<NotificationInfoBar message={info} updateTime={updateTime} />
		</StyledUl>
	);
};

export default ErrorInfoLabel;
